import React from 'react';
import { BoxIcon } from 'lucide-react';
import { trackAddToCart } from '../../hooks/useMetaPixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  icon?: BoxIcon;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  icon: Icon,
  fullWidth = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-4 text-lg font-bold transition-all duration-200 transform hover:-translate-y-0.5 active:translate-y-0 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#E6007A] hover:bg-[#FF4DA6] text-white shadow-lg shadow-pink-500/30 rounded-[14px]',
    secondary: 'bg-white border-2 border-[#E6007A] text-[#E6007A] hover:bg-pink-50 rounded-[14px]'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClass = `${baseStyles} ${variants[variant]} ${widthClass} ${className}`;
  if (href) {
    const handleClick = () => {
      if (href.includes('cart') || href.includes('argrutinas')) {
        trackAddToCart();
      }
    };
    return <a href={href} className={combinedClass} target="_blank" rel="noopener noreferrer" onClick={handleClick} data-id="element-156">
        {children}
        {Icon && <Icon className="ml-2 h-5 w-5" data-id="element-157" />}
      </a>;
  }
  return <button className={combinedClass} {...props} data-id="element-158">
      {children}
      {Icon && <Icon className="ml-2 h-5 w-5" data-id="element-159" />}
    </button>;
}